export default __webpack_public_path__ + "static/media/Depart-de feu.110854ff.svg";